import { render, staticRenderFns } from "./back-home.vue?vue&type=template&id=12d1bb4e"
import script from "./back-home.vue?vue&type=script&lang=js"
export * from "./back-home.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports